import {vnTemplate} from "./vnTemplate";
import {vnAppZone} from "../vnApp/vn_app_zone";

declare var ko: any;

export class brandSelector_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return `
                <!-- ko if: items().length != 0  -->
                    <!-- ko if: selected()  -->
                        <button data-bind=" css: selected().iconImage, click: onClick" class="btn secondary icon i-dropdown" type="button">
                            <span data-bind="text: selected().name"></span>
                        </button>
                    <!-- /ko -->
                    <!-- ko ifnot: selected() || items().length == 0  -->
                        <button data-bind="click: onClick" class="btn secondary icon i-dropdown" type="button"><span></span></button>
                    <!-- /ko -->
                    <ul  data-bind="foreach: items, css: { 'is-hidden': !isListShown()}" class="main-nav-list">
                            <li class="main-nav-item">
                                <a class="main-nav-link" data-bind="click: $parent.onChangeSelected, text: name, css: iconImage, attr: { href: '/brand/' + id + '/articles/' }"></a>
                            </li>
                    </ul>
                <!-- /ko -->
            `;
    }

    protected getTemplateName(): string{
        return "brandSelector-template";
    }

    protected getMainElementClasses(): Array<string>{
        return ["dropdown", "prop-dropdown"];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return  {
             selected: ko.observable()
            ,isListShown: ko.observable(false)
            ,items: ko.observableArray()
            ,onChangeSelected: function(brand){ huit_neuf_this.onChangeSelected(brand); }
            ,onClick: function(){ huit_neuf_this.onClick(); }
        };
    }

    public setItems(items: Array<{id: number, name: string, iconImage: string}>){
        this.getTemplateViewModel().items(items);
    }

    public setSelected(selected){
        this.getTemplateViewModel().selected(selected);
    }

    public setSelectedById(idSelected){

        let selection;
        for (let i of this.getTemplateViewModel().items()) {
            if( i.id==idSelected){
                selection = i;
            }
        }

        this.getTemplateViewModel().selected(selection);
    }

    private onChangeSelected(selected){

        this.caller.resetActiveMenus();
        this.setSelected(selected);
        this.caller.changeSelection( selected.id );
    }

    private onClick(){

        let isListShown = this.getTemplateViewModel().isListShown();
        this.getTemplateViewModel().isListShown(!isListShown);
    }


}



// WEBPACK FOOTER //
// ./vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/brandSelector_template.ts